<template>
    <b-container id="campaign-connect-rule-page" fluid>
        <b-row class="">
            <b-col cols="12">
                <div class="border-bottom mb-3 pb-3">
                    <h3>캠페인 연결 규칙 관리</h3>
                    <p class="fw-400 text-secondary mb-0">
                        캠페인 연결 규칙 관리
                    </p>
                </div>
            </b-col>
        </b-row>

        <b-tabs v-model="currentTab" card>
            <b-tab :title="$t('조건 관리')">
                <manage-condition/>

            </b-tab>
            <b-tab :title="$t('규칙 그륩 관리')">
                <manage-rule-group/>
            </b-tab>
            <b-tab :title="$t('캠페인 규칙 관리')">
                <manage-campaign-rule-set/>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>


import ManageCondition
    from '@shared/components/admin/pages/Management/CampaignConnectRule/Condition/ManageCondition.vue';
import ManageRuleGroup
    from '@shared/components/admin/pages/Management/CampaignConnectRule/RuleGroup/ManageRuleGroup.vue';
import ManageCampaignRuleSet
    from '@shared/components/admin/pages/Management/CampaignConnectRule/CampaignRuleSet/ManageCampaignRuleSet.vue';

export default {
    name: 'CampaignConnectRule',
    components: {
        ManageCampaignRuleSet,
        ManageRuleGroup,
        ManageCondition

    },
    data() {
        const mapTabName = {
            0: 'condition',
            1: 'ruleGroup',
            2: 'campaignRule'
        };
        // URL 의 ?tab= 을 초기 탭으로 반영한다. 예전에는 currentTab 을 0 으로
        // 고정하고 immediate watch 가 무조건 ?tab=condition 으로 push 해서,
        // ?tab=campaignRule 로 들어와도 조건 탭으로 튕겼다.
        const tabToIndex = {condition: 0, ruleGroup: 1, campaignRule: 2};
        const initialTab = tabToIndex[this.$route.query.tab] ?? 0;
        return {
            currentTab: initialTab,
            mapTabName
        };
    },
    computed: {},
    watch: {
        currentTab: {
            handler() {
                const nextTab = this.mapTabName[this.currentTab];
                // 이미 같은 탭이면 push 하지 않는다 (NavigationDuplicated 방지).
                if (this.$route.query.tab === nextTab) return;
                this.$router.push({
                    name: 'ManagingCampaignConnectRule',
                    query: {tab: nextTab}
                });
            },
            immediate: true
        }
    },
    created() {
    },
    beforeDestroy() {
    },
    methods: {}
};
</script>

<style lang="scss">
</style>
